export default {
  'operation.manageAccount': 'Kelola Akun',
  'operation.proxyAccount': 'Proxy Account',
  'operation.resetPassword': 'Ubah Kata Sandi',
  'operation.logout': 'Logout',
};
